// extracted by mini-css-extract-plugin
export default {"question":"Survey_question__k+ZKk","p":"Survey_p__9bsYx","result":"Survey_result__MlyXu"};